import React from 'react'
import Features from './Features'
import Intro from './Intro'
import Testimonials from './Testimonials'
import Tools from './Tools'
import Available from '../Available/Available'

const About = () => {
    return (
        <>
            <Intro />
            <Features />
            <Testimonials />
            <Tools />
            <Available />
        </>
    )
}

export default About